/**
 * AutoValet Shopify Theme - Main JavaScript
 */

(function() {
  'use strict';

  /* ========================================
     Mobile Navigation
     ======================================== */
  const mobileMenuToggle = document.getElementById('mobile-menu-toggle');
  const mobileNav = document.getElementById('mobile-nav');
  const mobileNavClose = document.getElementById('mobile-nav-close');

  if (mobileMenuToggle && mobileNav) {
    mobileMenuToggle.addEventListener('click', function() {
      mobileNav.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
  }

  if (mobileNavClose && mobileNav) {
    mobileNavClose.addEventListener('click', function() {
      mobileNav.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  }

  /* ========================================
     Search Overlay
     ======================================== */
  const searchToggle = document.getElementById('search-toggle');
  const searchOverlay = document.getElementById('search-overlay');

  if (searchToggle && searchOverlay) {
    searchToggle.addEventListener('click', function() {
      searchOverlay.classList.add('is-open');
      var input = searchOverlay.querySelector('input');
      if (input) input.focus();
    });

    searchOverlay.addEventListener('click', function(e) {
      if (e.target === searchOverlay) {
        searchOverlay.classList.remove('is-open');
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && searchOverlay.classList.contains('is-open')) {
        searchOverlay.classList.remove('is-open');
      }
    });
  }

  /* ========================================
     Quantity Buttons
     ======================================== */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.quantity-minus, .quantity-plus');
    if (!btn) return;

    var container = btn.closest('.product-page__quantity');
    if (!container) return;

    var input = container.querySelector('input[type="number"]');
    if (!input) return;

    var currentVal = parseInt(input.value, 10) || 1;
    var min = parseInt(input.min, 10) || 0;
    var max = parseInt(input.max, 10) || 99;

    if (btn.classList.contains('quantity-minus')) {
      if (currentVal > min) input.value = currentVal - 1;
    } else {
      if (currentVal < max) input.value = currentVal + 1;
    }

    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ========================================
     Sticky Header Shadow
     ======================================== */
  var header = document.getElementById('site-header');
  if (header) {
    window.addEventListener('scroll', function() {
      if (window.scrollY > 10) {
        header.style.boxShadow = '0 2px 10px rgba(0,0,0,0.08)';
      } else {
        header.style.boxShadow = 'none';
      }
    }, { passive: true });
  }

  /* ========================================
     FAQ Page — Search & Filter
     ======================================== */
  var faqSearch = document.getElementById('faq-search');
  var faqList = document.getElementById('faq-list');
  var faqFilters = document.getElementById('faq-filters');
  var faqNoResults = document.getElementById('faq-no-results');

  if (faqSearch && faqList) {
    faqSearch.addEventListener('input', function() {
      var term = this.value.toLowerCase().trim();
      var items = faqList.querySelectorAll('.faq-item');
      var categories = faqList.querySelectorAll('.faq-category');
      var visible = 0;

      items.forEach(function(item) {
        var question = item.querySelector('.faq-item__question span');
        var answer = item.querySelector('.faq-item__answer');
        var text = (question ? question.textContent : '') + ' ' + (answer ? answer.textContent : '');
        if (term === '' || text.toLowerCase().indexOf(term) > -1) {
          item.style.display = '';
          visible++;
        } else {
          item.style.display = 'none';
        }
      });

      // Hide empty categories
      categories.forEach(function(cat) {
        var catItems = cat.querySelectorAll('.faq-item');
        var catVisible = 0;
        catItems.forEach(function(ci) {
          if (ci.style.display !== 'none') catVisible++;
        });
        cat.style.display = catVisible === 0 ? 'none' : '';
      });

      if (faqNoResults) {
        faqNoResults.style.display = visible === 0 ? '' : 'none';
      }
    });
  }

  if (faqFilters) {
    faqFilters.addEventListener('click', function(e) {
      var btn = e.target.closest('.faq-filter');
      if (!btn) return;

      // Update active state
      faqFilters.querySelectorAll('.faq-filter').forEach(function(f) { f.classList.remove('active'); });
      btn.classList.add('active');

      var cat = btn.getAttribute('data-category');
      var categories = faqList.querySelectorAll('.faq-category');

      if (cat === 'all') {
        categories.forEach(function(c) { c.style.display = ''; });
      } else {
        categories.forEach(function(c) {
          c.style.display = c.getAttribute('data-category') === cat ? '' : 'none';
        });
      }

      // Clear search
      if (faqSearch) faqSearch.value = '';
      faqList.querySelectorAll('.faq-item').forEach(function(item) { item.style.display = ''; });
      if (faqNoResults) faqNoResults.style.display = 'none';
    });
  }

  /* ========================================
     Safety Documents — Search & Filter
     ======================================== */
  var safetySearch = document.getElementById('safety-search');
  var safetyTable = document.getElementById('safety-table');
  var safetyFilters = document.getElementById('safety-filters');
  var safetyNoResults = document.getElementById('safety-no-results');

  if (safetySearch && safetyTable) {
    safetySearch.addEventListener('input', function() {
      var term = this.value.toLowerCase().trim();
      var rows = safetyTable.querySelectorAll('.safety-docs__row');
      var visible = 0;

      rows.forEach(function(row) {
        var product = row.getAttribute('data-product') || '';
        var cells = row.textContent.toLowerCase();
        if (term === '' || product.indexOf(term) > -1 || cells.indexOf(term) > -1) {
          row.style.display = '';
          visible++;
        } else {
          row.style.display = 'none';
        }
      });

      if (safetyNoResults) {
        safetyNoResults.style.display = visible === 0 ? '' : 'none';
      }
    });
  }

  if (safetyFilters) {
    safetyFilters.addEventListener('click', function(e) {
      var btn = e.target.closest('.faq-filter');
      if (!btn) return;

      safetyFilters.querySelectorAll('.faq-filter').forEach(function(f) { f.classList.remove('active'); });
      btn.classList.add('active');

      var cat = btn.getAttribute('data-category');
      var rows = safetyTable.querySelectorAll('.safety-docs__row');

      rows.forEach(function(row) {
        if (cat === 'all' || row.getAttribute('data-category') === cat) {
          row.style.display = '';
        } else {
          row.style.display = 'none';
        }
      });

      // Clear search
      if (safetySearch) safetySearch.value = '';
      if (safetyNoResults) safetyNoResults.style.display = 'none';
    });
  }

})();
